<div class="error-page-container">
  <div class="error-card">
    <div class="icon-container">
      <span class="material-symbols-rounded error-icon">warning</span>
    </div>

    <h1 class="error-title">Nothing to send us right now</h1>



    <div class="helpful-info">
      <!-- <h3>Finding your link</h3> -->
      <p>
        If we need anything from you, this is where it will appear. We will email and text you a new link the moment
        there is something to do, however it is possible that we may still be outstanding some information from you.
        Please call us urgently on <a href="tel:{{supportPhone}}"><strong>{{supportPhone}}</strong></a> so that we can
        investigate this further. Please note that our opening
        hours are 9.00am-5.30pm, Monday to Friday
      </p>
    </div>


  </div>
</div>